.downloadPageWrapper {
	background-color: #000;
	position: relative;
	overflow: hidden;
	*,
	*::before,
	*::after {
		box-sizing: border-box;
	}

	.backgroundBlur {
		filter: blur(10rem);
		height: 100%;
		inset-block-start: max(calc(65svh - 16rem), calc(48rem * 0.65));
		inset: 0;
		object-fit: cover;
		opacity: 0.5;
		pointer-events: none;
		position: absolute;
		transform: translateZ(0);
		width: 100%;
	}
}
